module.exports = __webpack_public_path__ + "static/media/favicon-light.fb8ec563.png";